export const flavorsData = [
  {
    name: 'Chocolate Ice Cream',
  },
  {
    name: 'Vanilla ice cream',
  },
  {
    name: 'Twisted treat - combo of both',
  },
  {
    name: 'NSA Vanilla',
  },
  {
    name: 'Twist – berries and cream',
  },
  {
    name: 'Mountain Blackberry',
  },
  {
    name: 'White Chocolate Moouse',
  },
  {
    name: 'Twist – White Chocolate Oreo',
  },
  {
    name: 'Cookies and Cream',
  },
  {
    name: 'Darn Good Peanut Butter',
  },
  {
    name: 'Twist – PB Cup',
  },
  {
    name: 'Tripple Cocoa Chocolate',
  },
  {
    name: 'Watermelon Sorbet',
  },
  {
    name: 'Twist – tropical treat',
  },
  {
    name: 'Sunny Sorbet – Strawberry Kiwi',
  },
  {
    name: 'Birthday Cake',
  },
  {
    name: 'Twist - Strawberry Shortcake',
  },
  {
    name: 'Summertime Strawberry',
  },
];

export default {
  flavorsData,
};
